<template>
  <div>
    <v-card v-if="pgUrl === null" class="mt-12 mx-auto" max-width="80%">
      <v-row class="text-center">
        <v-col>
          <v-card-text>
            <v-icon class="mr-1" style="color: #59065d">mdi-account</v-icon
            >Subscriber ID
          </v-card-text>
          <h6>
            <b>{{ subscriberId }}</b>
          </h6>
        </v-col>

        <v-col>
          <v-card-text>
            <v-icon class="mr-1" style="color: #59065d">mdi-phone</v-icon>Mobile
            Number
          </v-card-text>
          <h6>
            <b>{{ mobileNo }}</b>
          </h6>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-card-text>
          <v-icon class="mr-1" style="color: #59065d">mdi-cash</v-icon>Current
          Balance
        </v-card-text>
        <h6>
          <span class="rupee">&#8377;</span>
          <b>{{ $toFixed(balance) }}</b>
        </h6>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          style="width: 50%"
          label=" Enter Recharge Amount "
          v-model="amount"
          placeholder="10-500"
          type="number"
          class="mx-auto mt-12"
          :rules="rules"
        />
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              :disabled="!valid"
              color="primary"
              class="mb-8 topup"
              @click="
                validate();
                handleSubmit();
              "
            >
              Proceed To Pay
            </v-btn>
            <!-- <v-btn
              :disabled="!valid"
              color="primary"
              class="mb-8 topup paytmbtn"
              @click="
                validate();
                handleSubmit();
              "
            >
              Proceed To Pay with Paytm
            </v-btn>
            <v-btn
              color="primary"
              class="mb-8 topup"
              @click="proceedToEassyPay"
            >
              Proceed To Pay with Easebuzz
            </v-btn> -->
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
    <payment-start
      v-else
      :action="pgUrl"
      :params="pgParams"
      :checksum="checkSum"
    />
    <v-snackbar v-model="showMessage" :color="color">{{ msg }}</v-snackbar>
  </div>
</template>
<script>
import PaymentStart from "./PaymentStart.vue";
import {
  // createRequestQuickPay as createRequestService,
  createRequest as createRequestService,
  getCount as getCountService,
  getStatus as getStatusService,
  createEasyBuzzRequest,
  // getCount,
} from "../../services/topup";
import { easebuzzGetStatus as easebuzzGetStatusService } from "../../services/quickpay";
import { EASY_BUZZ_URL } from "../../config";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  components: {
    PaymentStart,
  },
  data() {
    return {
      valid: true,
      showMessage: false,
      msg: "",
      color: "",
      amount: "",
      pgParams: {},
      //getCount: null,
      eassyParams: {},
      // name: this.$store.state["auth"].storePaymentData.name,
      // emailId: this.$store.state["auth"].storePaymentData.email,
      // phoneNumber: this.$store.state["auth"].storePaymentData.mobile,
      pgUrl: null,
      checkSum: null,
      rules: [
        (v) => !!v || "Required",
        (v) => v >= 1 || "Recharge amount should be above 1",
        (v) => v <= 10000 || "Max should not be above 10000",
      ],
    };
  },
  props: {
    status: Boolean,
  },
  computed: {
    ...mapGetters("auth", ["monthlyCost"]),
    ...mapState("auth", {
      mobileNo: (state) => state.mobile,
      email: (state) => state.email,
      balance: (state) => state.walletBalance,
      subscriberId: (state) => state.accountNo,
      name: ({ userInfo }) => userInfo.firstname,
    }),
    ...mapGetters("auth", ["isDP"]),
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    showSnack(msg, color) {
      this.msg = msg;
      this.color = color;
      this.showMessage = true;
    },
    async handleSubmit() {
      const resp = await getCountService();
      this.countResp = resp;
      this.proccedToPay();
    },
    async proccedToPay() {
      if (this.countResp == 0) {
        try {
          const { mobileNo, email, amount } = this;
          const result = await createRequestService({
            mobileNo,
            email,
            amount,
          });
          const { REDIRECT_URL, parameters } = result;
          const { CHECKSUMHASH, ...pgParams } = parameters;
          this.pgParams = pgParams;
          this.pgUrl = REDIRECT_URL;
          this.checkSum = CHECKSUMHASH;
          this.$nextTick(() => {
            document.f1.submit();
          });
        } catch (err) {}
      } else {
        try {
          const amount = this.$toFixed(this.balance);
          const customerId = this.subscriberId;
          const { name } = this;
          let phone = this.mobileNo;
          let email = this.email;
          if (phone == "") {
            phone = this.mobileNo;
          }
          if (email == "") {
            email = "bripl_missed@gmail.com";
          }
          const data = localStorage.getItem("in:user");
          let payload = {
            email: this.email,
            name: this.name,
            phone: this.mobileNo,
            productInfo: "Recharge",
            amount: this.amount,
            customerId: this.subscriberId,
          };
          let result = await createEasyBuzzRequest(payload);

          if (result.data) {
            window.location.href = `${EASY_BUZZ_URL}/${result.data}`;
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Please try again",
            });
          }
        } catch (err) {}
      }
    },
    ...mapActions("auth", ["getMonthlyCost"]),
    async proceedToEassyPay() {
      try {
        const amount = this.$toFixed(this.monthlyCost);
        const customerId = this.$store.state["auth"].storePaymentData
          .customerId;
        const { name } = this;
        let phone = this.phoneNumber;
        let email = this.emailId;
        if (phone == "") {
          phone = this.$store.state["auth"].storePaymentData.mobile;
        }
        if (email == "") {
          email = "bripl_missed@gmail.com";
        }
        const data = localStorage.getItem("in:user");
        let payload = {
          email: this.email,
          name: this.name,
          phone: this.mobileNo,
          productInfo: "Recharge",
          amount: this.amount,
          customerId: this.subscriberId,
        };
        let result = await createEasyBuzzRequest(payload);

        if (result.data) {
          window.location.href = `${EASY_BUZZ_URL}/${result.data}`;
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Please Enter Amount",
          });
        }
      } catch (err) {}
    },

    async easeBuzzStatusShow() {
      if (this.status === true) {
        const { id } = this.$route.params;
        setTimeout(() => {
          this.getBalance();
        }, 1000);
        const result = await easebuzzGetStatusService(id);
        if (result.status == "SUCCESS") {
          this.showSnack("Topup successful", "success");
        } else {
          this.showSnack("Topup failed", "error");
        }
      }
    },
    ...mapActions("auth", ["getBalance"]),
  },
  async mounted() {
    this.easeBuzzStatusShow();
    if (this.status === true) {
      const { id } = this.$route.params;
      setTimeout(() => {
        this.getBalance();
      }, 1000);
      const result = await getStatusService(id);
      const {
        response: {
          result: { status: transactionStatus },
        },
      } = result;
      if (transactionStatus == "TXN_SUCCESS") {
        this.showSnack("Topup successful", "success");
      } else {
        this.showSnack("Topup failed", "error");
      }
    }
  },
};
</script>
<style scoped>
.rupee {
  margin-right: 5px;
  font-weight: 500 !important;
}
</style>
<style>
.topup {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}
.paytmbtn {
  width: 270px;
}
</style>
